import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {ListItemIcon} from "@material-ui/core";
import LockSharpIcon from "@material-ui/icons/LockSharp";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {ConfirmationPrompt} from "../../../ui/ConfirmationPrompt";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import Link from "@material-ui/core/Link";
import {unassignSubscription} from "../../../../api/organization-unit-functions";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

const useStyles = makeStyles(theme => ({
    multipleSubscription: {
        display: 'flex',
        width: 250
    },
    multipleSubscriptionFontSize: {
        fontSize: '0.8rem'
    },
    multipleSubscriptionTextAlignRight: {
        textAlign: 'right'
    },
    multipleSubscriptionDeleteAction: {
        fontSize: '0.8rem',
        textAlign: 'right'
    },
    multipleSubscriptionLock: {
        justifyContent: 'flex-end'
    }
}));

export const MultipleSubscriptionType = (props: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const {subscriptions, organizationId, organizationUnitId, onSubscriptionRemoved} = props;
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [disableConfirmation, setDisableConfirmation] = useState(false);
    const {handleError} = useApiNotification();
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [, setAnchorEl] = React.useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onRemoveSubscription = async (id: any) => {
        setShowConfirmation(true);
        setSubscriptionId(id);
    };

    const handleRemoveSubscription = async () => {
        setDisableConfirmation(true);
        await unassignSubscription(organizationId, organizationUnitId, subscriptionId!)
            .then(() => {
                onSubscriptionRemoved()
            })
            .catch(handleError)
            .finally(() => {
                setDisableConfirmation(false);
                setShowConfirmation(false);
                setSubscriptionId(null);
                handleClose();
            });
    };

    return (
        <List>
            {
                subscriptions.map((subscription: any) => {
                    const lastSubscription = subscriptions[subscriptions.length - 1].id;
                    return (
                        <div key={subscription.id}>
                            <ListItem divider={(subscription.id !== lastSubscription)}
                                      className={classes.multipleSubscription}>
                                <Grid container justify={"space-around"}>
                                    <Grid item xs>
                                        {
                                            (subscription.source === 'OrganizationUnit' && subscription.isExpired) ?
                                                <ListItemText classes={{primary: classes.multipleSubscriptionFontSize}}
                                                              primary={t(`Subscription.Tags.Expired`)}/> :
                                                <ListItemText classes={{primary: classes.multipleSubscriptionFontSize}}
                                                              primary={t(`_Shared.SubscriptionType.${subscription.type}`)}/>
                                        }
                                    </Grid>
                                    <Grid item xs>
                                        {(() => {
                                            if (subscription.source === "OrganizationUnit") {
                                                return <ListItemText
                                                    classes={{
                                                        root: classes.multipleSubscriptionTextAlignRight,
                                                        primary: classes.multipleSubscriptionFontSize
                                                    }}
                                                    primary={
                                                        subscription.expirationDate
                                                    }/>;
                                            }
                                        })()}
                                    </Grid>
                                    {
                                        subscription.source === "OrganizationUnit" ?
                                            <Grid item xs>
                                                <ListItemSecondaryAction
                                                    className={classes.multipleSubscriptionDeleteAction}>
                                                    <Link
                                                        component="button"
                                                        underline={'always'}
                                                        color={'primary'}
                                                        onClick={() => onRemoveSubscription(subscription.id)}>
                                                        {t('_Common.Labels.Remove')}
                                                    </Link>
                                                </ListItemSecondaryAction>
                                            </Grid>
                                            :
                                            <ListItemIcon className={classes.multipleSubscriptionLock}>
                                                <LockSharpIcon/>
                                            </ListItemIcon>
                                    }
                                </Grid>
                            </ListItem>
                        </div>
                    );
                })
            }
            <ConfirmationPrompt
                title={t(`Subscription.Membership.RemoveSubscription.Title`)}
                description={t(`Subscription.Membership.RemoveSubscription.ConfirmationMessage`)}
                confirmationButtonKey={t('_Common.Labels.Confirm')}
                open={showConfirmation}
                disable={disableConfirmation}
                onCancel={() => {
                    handleClose();
                    setShowConfirmation(false);
                }}
                onConfirm={() => handleRemoveSubscription()}/>
        </List>
    );
};
